import { useIsMutating, useMutation } from "@tanstack/react-query";
import { useRef } from "react";

import { BANNER_CACHE_KEYS } from "./keys";

import { BannerRepository } from "@/repositories/banner";

export const useUploadBannerImage = () => {
  const bannerRepository = useRef(new BannerRepository());

  return useMutation({
    mutationKey: BANNER_CACHE_KEYS.UPLOAD_IMAGE,
    mutationFn: (file: File) => bannerRepository.current.uploadImage(file),
  });
};

export const useIsUploadingBannerImage = (): boolean =>
  useIsMutating({ mutationKey: BANNER_CACHE_KEYS.UPLOAD_IMAGE }) > 0;
